import { faVideo } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { EditorView } from "prosemirror-view";

import { Extension } from "../../extension";
import openRecordVideoModal from "./RecordVideoModal";

export default class RecordVideo extends Extension {
	name = "RecordVideo";

	constructor() {
		super();
	}

	menuEntry(view: EditorView) {
		return {
			title: "Record video",
			subtitle: "If a picture is worth 1000 words…",
			tooltip: "Record video",
			icon: faVideo,
			section: "types" as const,
			group: "insert",
			hideOnMediumScreen: true,
			run: () => () => {
				openRecordVideoModal(view);
				return true;
			},
		};
	}
}
